import {useEffect} from 'react'

import {useAppDispatch} from '../../../../hooks/react-redux'
import {noop} from '../../../../utils/empty'
import {shortcuts} from '../Shortcuts.slices'
import type {GlobalSearchKind} from '../Shortcuts.types'

interface Props {
  kind?: GlobalSearchKind
}
export const useSearchShortcutEffect = ({kind}: Props) => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (kind) {
      dispatch(shortcuts.actions.addSearch(kind))

      return () => {
        dispatch(shortcuts.actions.removeSearch(kind))
      }
    }
    return noop
  }, [dispatch, kind])
}
